import ServiceCards3Cart from './components/ServiseCardsCard/ServiceCards3Card';
import styles from './serviceCards.module.scss';
import { ServiceCardsType } from '@/types/serviceCards.types';

const ServiceCards3CardMaintenance = ({
  cards,
  title,
  text,
}: ServiceCardsType) => {
  return (
    <section className={styles.serviceCards}>
      <div className="container">
        {title && (
          <h2
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h2>
        )}
        {text && <p className={styles.text}>{text}</p>}

        <div className={styles.cardsContainer}>
          {cards.map((card) => (
            <ServiceCards3Cart key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards3CardMaintenance;
